<template>
	<div class="processing" :class="{ 'processing--dark': darkTheme }">
		<div class="customer-name-wrap">
			<span v-if="customerNameToPrint" class="customer-name">
				{{ customerNameToPrint }}
			</span>
		</div>

		<span class="text-loader">Submitting order</span>
		<span
			class="smart-tab-logo"
			:class="{ 'smart-tab-logo--light': darkTheme }"
		>
			SmartTab
		</span>

		<animated-logo />

		<span class="processing-status">PREPARING ORDER</span>
		<span class="processing-description">
			CONFIRM YOUR PAYMENT ON THE NEXT SCREEN TO FINALIZE YOUR ORDER
		</span>
	</div>
</template>

<script>
import AnimatedLogo from '@/components/Loaders/AnimatedLogo.vue'

export default {
	name: 'RegularTabProcessing',
	components: {
		AnimatedLogo
	},
	props: {
		customerNameToPrint: {
			type: String,
			default: ''
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.processing {
	position: absolute;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%;
	padding: 48px 24px 24px;
	text-transform: uppercase;
	text-align: center;

	&--dark {
		.customer-name,
		.text-loader {
			color: $white;
		}
	}
}

.customer-name-wrap {
	min-height: 40px;
	padding: 0 0 10px;
}

.customer-name {
	font-size: 16px;
	font-weight: 800;
	color: #1d1b25;
	text-transform: none;
	letter-spacing: 1px;
}

.text-loader {
	display: block;
	padding: 0 0 160px;
	font-size: 24px;
	font-weight: 300;
	color: #1d1b25;
}

.smart-tab-logo {
	display: block;
	margin: 0 auto 142px;
}

.processing-status {
	display: inline-block;
	padding: 0 20px 12px;
	margin: 0 0 8px;
	font-size: 20px;
	color: #816cc2;
	border-bottom: 1px solid #554781;
}

.processing-description {
	display: block;
	max-width: 244px;
	margin: 0 auto 22px;
	line-height: 1.4;
	color: $white;
}

@media (max-width: 767px) {
	.processing {
		padding: 24px 12px 12px;
	}

	.text-loader {
		padding: 0 0 100px;
		font-size: 24px;
	}

	.smart-tab-logo {
		margin: 0 auto 20px;
	}
}
</style>
